import styles from './BundleSelection.module.css';
import Icon from '@/components/Icons/Icon';
import iconStyles from '@/components/Icons/Icon.module.css';
import LinkedBundleTableCard from '../LinkedBundleTableCard/LinkedBundleTableCard';
import { BundleSelectionProps } from '../CreateLinkedBundles.types';
import { useTranslation } from 'react-i18next';

export const BundleSelection = (props: BundleSelectionProps) => {
  const { t } = useTranslation();
  const { bundleData, selectedRows, setSelectedRows, selectedBundles } = props;

  const columns = [
    {
      accessorKey: 'code',
      header: 'Bundle Code',
      enableSorting: true,
    },
    {
      accessorKey: 'name',
      header: 'Display Name',
      enableSorting: true,
    },
    {
      accessorKey: 'internalName',
      header: 'Bundle Desc.',
      enableSorting: true,
    },
  ];

  return (
    <div className={styles.stepTwo}>
      <div>
        <div className={styles.infoContainer}>
          <div className={styles.infoIcon}>
            <Icon iconName="Info" className={iconStyles.iconButton} />
          </div>
          <p>{t('bundleLibrary.settingsLinked')}</p>
        </div>
        <div className={styles.accordionContainer}>
          <div className={styles.linkedBundleTableCards}>
            <LinkedBundleTableCard
              enableRowSelection
              width="calc(100vw - 250px)"
              title={t('bundleLibrary.table.title')}
              data={bundleData}
              selectedRows={selectedRows}
              onRowSelectionChange={setSelectedRows}
              columns={columns}
              returnedRecordsText={(count) => t('bundleLibrary.table.returnedRecord', { count })}
              enableFilters
            />
          </div>
          <div className={styles.linkedBundleTableCards}>
            <LinkedBundleTableCard
              width="calc(100vw - 250px)"
              title={t('bundleLibrary.table.selected')}
              data={selectedBundles}
              columns={columns}
              returnedRecordsText={(count) => t('bundleLibrary.table.returnedRecord', { count })}
              enableFilters
            />
          </div>
        </div>
      </div>
    </div>
  );
};
